export default __webpack_public_path__ + "static/media/new_02.6a749db9.jpg";